    <template>
    <v-ons-page>
        <div class="page-header">
            <img src="../assets/hynds-vip.svg" width="74px" style="width:74px;" class="logo">
        </div>
        <div>
        <v-ons-row>
            <v-ons-col>
                <div v-if="initialized" :key="trip.timestamp">
                    <v-ons-card>
                        <div class="card__image">
                            <img :src="imgPath(tripData.attributes.image)" :alt="_.get(tripData, 'attributes.image.name')">
                            <span class="card__image__year">{{ _.get(tripData, 'attributes.year')}}</span>
                            <div v-if="_.get(tripData, 'attributes.trip_type') == 'Gold'" class="card__persons">
                                <div class="person-icon">
                                    <span class="person-count">{{ _.get(tripData, 'attributes.pax') }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="qualified" class="title title--complete">
                            <h2>{{ _.get(tripData, 'attributes.name') }}</h2>
                            <p>{{ confirmationMessage }}</p>
                        </div>
                        <template v-else>
                        <div class="title">
                            {{ _.get(tripData, 'attributes.name') }}
                        </div>
                        <div class="content">
                            <div class="progress-container">
                                <span>Your progress</span>
                                <em v-if="qualified" class="progress-note text-success">Trip earned!</em>
                                <em v-else-if="progress >= 90" class="progress-note text-success">Nearly there!</em>

                                <span>{{ progress+'%' }}</span>
                            </div>
                            <v-ons-progress-bar :value="progress"></v-ons-progress-bar>

                            <p class="intro" v-if="_.get(tripData, 'attributes.intro')">{{ _.get(tripData, 'attributes.intro') }}</p>

                        </div>
                        </template>

                    </v-ons-card>

                    <div v-if="qualified" class="copy text-center">
                        <h1>Congratulations!</h1>
                        <p class="intro">You've reached your target for the <strong>{{ _.get(tripData, 'attributes.name') }}</strong>! You can now unlock another {{ currentYear }} trip or one in {{ nextYear }}.</p>
                   </div>
                </div>
                <div v-else class="text-center page-progress-loader">

                    <v-ons-progress-circular
                        indeterminate
                        ></v-ons-progress-circular>
                </div>
            </v-ons-col>
        </v-ons-row>
        </div>
</v-ons-page>
</template>

<script>
import Utils from './mixins/Utils'
import Module from './mixins/Module'

export default {
    data () {
        return {
            initialized: false,
            processing: false,
        }
    },

    created() {
        this.$emit('init', {
            name: 'trip',
            title: 'Your Travel Points',
            showMenu: true,
            showFooter: false,
        })

        if (!this.customer.content.id) {
            return this.$router.push({ name: 'login' });
        }

        let tripId = this.$route.params.id;
        this.trip.getInitialData(`/my/all_trips/${tripId}`, {
            token: this.getToken(),
        }).then(() => {
            this.initialized = true;
        })
    },

    mixins: [
        Utils,
        Module('customer'),
        Module('trip'),
    ],

    computed: {
        tripData() {
            return _.get(this.trip, 'content') || {};
        },

        customerData() {
            return _.get(this.customer, 'content.attributes') || {}
        },

        customerType() {
            return _.get(this.customer, 'content.attributes.customer_type');
        },

        isGoldCustomer() {
            return this.customerType == 'Gold';
        },

        confirmationMessage() {
            return _.get(this.trip, 'content.attributes.confirmation_message');
        },

        progress() {
            return _.get(this.trip, 'content.attributes.percentage', 0);
        },

        qualified() {
            return this.progress >= 100;
        },

        currentYear() {
            return _.get(this.tripData, 'attributes.year');
        },
        nextYear() {
            return Number(this.currentYear) + 1;
        },
    },

    methods: {
        registerTrip() {
            this.processing = true;
            return this.trip.updateData({
                data: {
                    redeemed_customer_id: this.customerData.id,
                }
            }).then(() => {
                let tripName = _.get(this.tripData, 'attributes.name');
                this.alert(`Congratulation on your trip to ${tripName}`);
                this.processing = false;
                this.$forceUpdate();
            })
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo{
    margin-bottom: 16px;
}
h1{
    text-transform: uppercase;
    margin-bottom: 8px;
}
.copy{
    padding-top: 0;
    padding-bottom: 0;
}
img {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/TripPage.vue